import type { AppState } from '@store/types'

export const selectCrawlImportPreparing = (state: AppState) =>
  state.crawlImport.preparing
